export const RESET = 'EXSBDELIVERY_UPDATE_RESET'
export const SET_ERROR = 'EXSBDELIVERY_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBDELIVERY_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBDELIVERY_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBDELIVERY_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBDELIVERY_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBDELIVERY_UPDATE_UPDATE_RETRIEVED'
